import React from "react";
import { usePlans } from "../../plans/PlansContext";
import Popover from "../../components/ui/Popover";
import Icon from "../../components/ui/Icon";

// "Add to plan" menu: the existing plans, newest first, plus a new one.
// onAdded(message, planId) lets the page show a toast with "Open plan".
export default function AddToPlan({ channels, onAdded, triggerClass = "btn", align = "left" }) {
  const { plans, createPlan, addChannels } = usePlans();
  const n = channels.length;
  const word = n === 1 ? "channel" : "channels";

  return (
    <Popover
      align={align}
      triggerClass={triggerClass}
      trigger={
        <>
          <Icon name="briefcase" /> Add to plan
        </>
      }
    >
      {(close) => (
        <div className="add-plan">
          <button
            type="button"
            className="menu-item"
            onClick={() => {
              const plan = createPlan({ channels });
              close();
              onAdded(`Started ${plan.name} with ${n} ${word}`, plan.id);
            }}
          >
            <Icon name="plus" /> New plan with {n === 1 ? "this channel" : `these ${n} channels`}
          </button>

          {plans.length > 0 && (
            <>
              <div className="menu-sep" />
              <div className="menu-label">Add to an existing plan</div>
              <div className="add-plan-list">
                {plans.map((p) => {
                  const inPlan = new Set(p.items.map((i) => i.channelId));
                  const already = channels.filter((c) => inPlan.has(c.id)).length;
                  const all = already === n;
                  return (
                    <button
                      key={p.id}
                      type="button"
                      className="menu-item"
                      disabled={all}
                      title={all ? `Already in ${p.name}` : undefined}
                      onClick={() => {
                        const added = addChannels(p.id, channels);
                        close();
                        onAdded(
                          already
                            ? `Added ${added} to ${p.name} (${already} already there)`
                            : `Added ${added} ${added === 1 ? "channel" : "channels"} to ${p.name}`,
                          p.id
                        );
                      }}
                    >
                      <span className="add-plan-name">{p.name}</span>
                      <span className="add-plan-n">{all ? "added" : `${p.items.length}`}</span>
                    </button>
                  );
                })}
              </div>
            </>
          )}
        </div>
      )}
    </Popover>
  );
}
